<template>
  <div id="news-dynamic-info">
    <div class="title">
      <span>新闻动态</span>
      <dv-decoration-2 style="height:10px;" />
    </div>
    <div class="details">
      <dv-scroll-board :config="config"/>
    </div>
  </div>
</template>

<script>
    let config = {
      header: ['创建时间', '热点新闻标题'],
      data: [
        ['2021年04月06日', '<a href="https://mp.weixin.qq.com/s/bhFn9_FKnOn-XxjhoLv6UQ" target="_blank" rel="noopener noreferrer" style="color: #FFFFFF">学习之窗|天天学党史</a>'],
        ['2021年04月06日', '<a href="https://mp.weixin.qq.com/s/fB77nvV0P6l_8NspYegqoQ" target="_blank" rel="noopener noreferrer" style="color: #FFFFFF">综合执法：春耕生产忙，无证的农药不可买</a>'],
        ['2021年04月05日', '<a href="https://mp.weixin.qq.com/s/NXkRIv8suGv-YZEqc2i2jA" target="_blank" rel="noopener noreferrer" style="color: #FFFFFF">祭祖踏青好时节，服务保障不松懈</a>'],
        ['2021年04月04日', '<a href="https://mp.weixin.qq.com/s/2zPSYKBFD2s0510zDanvXA" target="_blank" rel="noopener noreferrer" style="color: #FFFFFF">清明节，他们全力保障市容环境“清、明、洁”</a>'],
        ['2021年04月03日', '<a href="https://mp.weixin.qq.com/s/0U7aQnV3qQ5I2YSxphG4Fw" target="_blank" rel="noopener noreferrer" style="color: #FFFFFF">数字治理：400多套扬尘在线监测仪，科技赋能余杭，打响蓝天保卫战</a>'],
        ['2021年04月03日', '<a href="https://mp.weixin.qq.com/s/GMzJESSlmiwRdEaS9YmNfQ" target="_blank" rel="noopener noreferrer" style="color: #FFFFFF">兰动杭城｜2021年杭州市民兰花节开幕 上官兰花亮相长三角蕙兰精品展</a>'],
        ['2021年04月02日', '<a href="https://mp.weixin.qq.com/s/wl0tjyZDxxpKBMSjCVk1iw" target="_blank" rel="noopener noreferrer" style="color: #FFFFFF">城市绿地再“靓颜”，奏响春日保障 “进行曲”</a>'],
        ['2021年04月02日', '<a href="https://mp.weixin.qq.com/s/-TefkVf4MA4Fln7Wa2oQpw" target="_blank" rel="noopener noreferrer" style="color: #FFFFFF">在家里这样做垃圾分类，让家庭生活更舒畅！</a>'],
        ['2021年03月30日', '<a href="https://mp.weixin.qq.com/s/Ao7buJioOv_tmtQs05asMA" target="_blank" rel="noopener noreferrer" style="color: #FFFFFF">迎亚运 展风采|上官乡3月份党员垃圾分类成绩出来啦！</a>'],
        ['2021年03月29日', '<a href="https://mp.weixin.qq.com/s/BAJ61ypXXaixLkTJa_jO9g" target="_blank" rel="noopener noreferrer" style="color: #FFFFFF">浙江新闻客户端:杭州举办山乡“兰花大会”</a>']
      ],
      align: ['left','left'],
      columnWidth: [130],
      rowNum: 8,
      waitTime: 2500,
      headerBGC: '#1981f6',
      headerHeight: 30,
      oddRowBGC: 'rgba(0, 44, 81, 0.8)',
      evenRowBGC: 'rgba(10, 29, 50, 0.8)'
    };

    export default {
      name: "NewsDynamic",
      data(){
        return{
          config
        }
      },
      methods:{
      },
      mounted() {

      }
    }
</script>

<style lang="less" scoped>
  #news-dynamic-info{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px;
    cursor: pointer;

    .title{
      width: 100%;
      text-align: center;
      font-size: 1.1em;
      color: #ffffff;
    }

    .details{
      width: 100%;
      height: 90%;
      padding-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/datav/NewsDynamic.vue